export var InboxConversationStatus;
(function (InboxConversationStatus) {
    InboxConversationStatus["OPEN"] = "open";
    InboxConversationStatus["RESOLVED"] = "resolved";
    InboxConversationStatus["ARCHIVED"] = "archived";
})(InboxConversationStatus || (InboxConversationStatus = {}));
export var InboxConversationChannel;
(function (InboxConversationChannel) {
    InboxConversationChannel["EMAIL"] = "email";
    InboxConversationChannel["SMS"] = "sms";
})(InboxConversationChannel || (InboxConversationChannel = {}));
//# sourceMappingURL=inboxConversation.js.map